import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from './module';

export const TASKS_FETCH = prefix('TASKS_FETCH');
export const [TASKS_FETCH_STARTED, TASKS_FETCH_SUCCEEDED, TASKS_FETCH_FAILED] = createAsyncActionTypes(TASKS_FETCH);

export const CUSTOMER_BALANCE_FETCH = prefix('CUSTOMER_BALANCE_FETCH');

export const RATES_FETCH = prefix('RATES_FETCH');
export const [RATES_FETCH_STARTED, RATES_FETCH_SUCCEEDED, RATES_FETCH_FAILED] = createAsyncActionTypes(RATES_FETCH);

export const RESOURCES_FETCH = prefix('RESOURCES_FETCH');
export const [RESOURCES_FETCH_STARTED, RESOURCES_FETCH_SUCCEEDED, RESOURCES_FETCH_FAILED] =
    createAsyncActionTypes(RESOURCES_FETCH);

export const RESERVATIONS_FETCH = prefix('RESERVATIONS_FETCH');
export const [RESERVATIONS_FETCH_STARTED, RESERVATIONS_FETCH_SUCCEEDED, RESERVATIONS_FETCH_FAILED] =
    createAsyncActionTypes(RESERVATIONS_FETCH);

export const PASSPORT_SCANNER_COMMAND_FETCH = prefix('PASSPORT_SCANNER_COMMAND_FETCH');

export const RESERVATION_MEMBERSHIP_UPLOAD = prefix('RESERVATION_MEMBERSHIP_UPLOAD');

export const ORDER_ITEMS_CANCEL = prefix('ORDER_ITEMS_CANCEL');

export const CHECK_IN_AND_CUT = prefix('CHECK_IN_AND_CUT');

export const UNDO_CHECK_IN = prefix('UNDO_CHECK_IN');

export const UNDO_CHECK_OUT = prefix('UNDO_CHECK_OUT');

export const RESERVATION_CONFIRMED = prefix('RESERVATION_CONFIRMED');

export const RESERVATION_CANCELLED = prefix('RESERVATION_CANCELLED');

export const CHECK_OUT = prefix('CHECK_OUT');

export const RESERVATION_TOGGLE_CHECKED = prefix('RESERVATION_TOGGLE_CHECKED');

export const RESERVATIONS_SET_CHECKED = prefix('RESERVATIONS_SET_CHECKED');

export const RESERVATION_TOGGLE_OPENED = prefix('RESERVATION_TOGGLE_OPENED');

export const RESERVATIONS_SET_OPENED = prefix('RESERVATIONS_SET_OPENED');

export const RESERVATION_TOGGLE_SHOW_ALL_NOTES = prefix('RESERVATION_TOGGLE_SHOW_ALL_NOTES');

export const RESERVATION_LOAD_CANCELED = prefix('RESERVATION_LOAD_CANCELED');
export const GUESTS_DIALOG_OPENED = prefix('GUESTS_DIALOG_OPENED');
export const GUESTS_DIALOG_CLOSED = prefix('GUESTS_DIALOG_CLOSED');
export const SPACE_DIALOG_OPENED = prefix('SPACE_DIALOG_OPENED');
export const SPACE_DIALOG_CLOSED = prefix('SPACE_DIALOG_CLOSED');

export const SET_NOTE_IDS_TO_BE_DELETED = prefix('SET_NOTE_IDS_TO_BE_DELETED');

export const BALANCES_FETCH = prefix('BALANCES_FETCH');
export const [BALANCES_FETCH_STARTED, BALANCES_FETCH_SUCCEEDED, BALANCES_FETCH_FAILED] =
    createAsyncActionTypes(BALANCES_FETCH);

export const SET_SELECTED_RESERVATION_SERVICE_ID = prefix('SET_SELECTED_RESERVATION_SERVICE_ID');
export const CUT_KEYS = prefix('CUT_KEYS');

export const CHANGE_TAB = prefix('CHANGE_TAB');

export const RESERVATION_STATE_CLEANED = prefix('RESERVATION_STATE_CLEANED');

export const ORDER_ITEMS_FETCH = prefix('ORDER_ITEMS_FETCH');

export const [ORDER_ITEMS_FETCH_STARTED, ORDER_ITEMS_FETCH_SUCCEEDED, ORDER_ITEMS_FETCH_FAILED] =
    createAsyncActionTypes(ORDER_ITEMS_FETCH);

export const AVAILABILITIES_FETCH = prefix('AVAILABILITIES_FETCH');
